import { render } from "./badSceneLine.vue?vue&type=template&id=3580527c&scoped=true"
import script from "./badSceneLine.vue?vue&type=script&lang=js"
export * from "./badSceneLine.vue?vue&type=script&lang=js"

import "./badSceneLine.vue?vue&type=style&index=0&id=3580527c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3580527c"]])

export default __exports__